import { Action } from 'redux';

import { IOrderClause } from '../../../ts/ServerApi/types/IOrderClause';
import { SelectSortOrder } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SelectSortOrderAction extends Action {
  readonly order: ReadonlyArray<IOrderClause>;
}

export function selectSortOrder(order: ReadonlyArray<IOrderClause>): SelectSortOrderAction {
  return {
    type: SelectSortOrder,
    order
  };
}

export const isSelectSortOrderAction = isActionFactory<SelectSortOrderAction>(SelectSortOrder);
